import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines clsx and tailwind-merge for optimal class name handling.
 *
 * - clsx: Handles conditional classes, arrays, objects, and falsy values
 * - tailwind-merge: Intelligently merges Tailwind CSS classes to avoid conflicts
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-blue-500', { 'opacity-50': isDisabled })
 * cn('p-4', className) // className overrides default padding
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
